import axios from 'axios'
import { MATRIZ_ADS_TAG, matrizAdsDebugEnabled } from '@/utils/matrizAdsDebug'

const rawBase = process.env.VUE_APP_ROOT_API_URL
const baseURL =
  typeof rawBase === 'string' ? rawBase.trim().replace(/\/$/, '') : ''

if (!baseURL && process.env.NODE_ENV === 'production') {
  // Evita bundle “silencioso” com baseURL vazia em homolog/prod
  // eslint-disable-next-line no-console
  console.error(
    '[axios] VUE_APP_ROOT_API_URL não definido no build. Defina em .env.production ou no CI.',
  )
}

const api = axios.create({
  baseURL: baseURL || undefined,
  headers: {
    Authorization: 'Bearer ' + localStorage.getItem('jwt'),
  },
})

const ADS_URL_SNIPPET_RE = /links-ads-new|facebookads|pdfads/i

function isAdsRelatedUrl(config) {
  const u = String(config?.url || '')
  return ADS_URL_SNIPPET_RE.test(u)
}

api.interceptors.request.use(
  async (config) => {
    const token = await localStorage.getItem('jwt')
    //console.log(token)
    if (token) {
      config.headers.Authorization = 'Bearer ' + token
      //console.log(config.headers.Authorization)
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

api.interceptors.request.use(
  (config) => {
    try {
      if (matrizAdsDebugEnabled() && isAdsRelatedUrl(config)) {
        console.info(`${MATRIZ_ADS_TAG} HTTP REQ`, {
          method: (config.method || 'get').toUpperCase(),
          url: `${config.baseURL || ''}${config.url || ''}`,
          params: config.params,
          hasAuth: !!config.headers?.Authorization,
        })
      }
    } catch {
      /* ignore */
    }
    return config
  },
  (error) => Promise.reject(error),
)

api.interceptors.response.use(
  (response) => {
    try {
      if (matrizAdsDebugEnabled() && isAdsRelatedUrl(response.config)) {
        const d = response.data
        const preview =
          Array.isArray(d) && d.length > 5
            ? { type: 'array', length: d.length, first: d[0] }
            : d && typeof d === 'object' && !Array.isArray(d)
              ? { type: 'object', keys: Object.keys(d).slice(0, 20) }
              : { type: typeof d }
        console.info(`${MATRIZ_ADS_TAG} HTTP OK`, {
          status: response.status,
          url: `${response.config.baseURL || ''}${response.config.url || ''}`,
          bodyPreview: preview,
        })
      }
    } catch {
      /* ignore */
    }
    return response
  },
  (error) => {
    try {
      if (isAdsRelatedUrl(error.config)) {
        const res = error.response
        console.error(`${MATRIZ_ADS_TAG} HTTP ERRO`, {
          message: error.message,
          url: error.config
            ? `${error.config.baseURL || ''}${error.config.url || ''}`
            : undefined,
          method: error.config?.method,
          params: error.config?.params,
          status: res?.status,
          statusText: res?.statusText,
          data: res?.data,
        })
      }
    } catch {
      /* ignore */
    }
    return Promise.reject(error)
  },
)

export default api
